import { all } from 'redux-saga/effects'
import FetchTutorSaga from './FetchTutorSaga'
import SignIn from './SignInSaga'
import FetchLessonsSaga from './FetchLessonsSaga'
import FetchTimeSlotsSaga from './FetchTimeSlotsSaga'
import CreateTimeSlotSaga from './CreateTimeSlotSaga'
import AcceptLessonSaga from './AcceptLessonSaga'
import UpdateTutorSaga from './UpdateTutorSaga'
import ResetConnectionSaga from './ResetConnectionSaga'
import HandleSlidesWsMessageSaga from './HandleSlidesWsMessageSaga'
import HandleChatWsMessageSaga from './HandleChatWsMessageSaga'
import FetchUnitsSaga from './FetchUnitsSaga'
import FetchLessonSaga from './FetchLessonSaga'
import FetchLessonPlans from './FetchLessonPlansSaga'
import ChangeLessonPlanSaga from './ChangeLessonPlanSaga'
import HandlePresenceReportSaga from './HandlePresenceReportSaga'
import TimeOutResetConnectionSaga from './TimeOutResetConnectionSaga'
import ResetKurentoSaga from './ResetKurentoSaga'
import CreateUnitSaga from './CreateUnitSaga'
import UpdateUnitSaga from './UpdateUnitSaga'
import CreateLessonPlan from './CreateLessonPlan'
import ReorderLessonPlan from './ReorderLessonPlan'
import FetchSlidesSaga from './FetchSlidesSaga'
import CreateSlideSaga from './CreateSlideSaga'
import ReorderSlidesSaga from './ReorderSlidesSaga'
import UpdateSlideSaga from './UpdateSlideSaga'
import UploadSlideImageSaga from './UploadSlideImageSaga'
import CreateRoomSaga from './CreateRoomSaga'
import FetchExercisesSaga from './FetchExercisesSaga'
import UpdateExercisesSaga from './UpdateExercisesSaga'
import DeleteExerciseSaga from './DeleteExerciseSaga'
import CreateExerciseSaga from './CreateExerciseSaga'
import ExtendLessonSaga from './ExtendLessonSaga'
import AddChatMessageNotificationSaga from './AddChatMessageNotificationSaga'
import RemoveSlideSaga from './RemoveSlideSaga'
import SendResetPasswordLinkSaga from './SendResetPasswordLinkSaga'
import UpdatePasswordSaga from './UpdatePasswordSaga'
import CreateTutorSaga from './CreateTutorSaga'
import DeleteLessonPlanSaga from './DeleteLessonPlanSaga'

export function* rootSaga(): Generator {
  yield all([
    FetchTutorSaga(),
    SignIn(),
    FetchLessonsSaga(),
    FetchTimeSlotsSaga(),
    CreateTimeSlotSaga(),
    AcceptLessonSaga(),
    UpdateTutorSaga(),
    ResetConnectionSaga(),
    HandleSlidesWsMessageSaga(),
    HandleChatWsMessageSaga(),
    FetchUnitsSaga(),
    FetchLessonSaga(),
    FetchLessonPlans(),
    ChangeLessonPlanSaga(),
    HandlePresenceReportSaga(),
    TimeOutResetConnectionSaga(),
    ResetKurentoSaga(),
    CreateUnitSaga(),
    UpdateUnitSaga(),
    CreateLessonPlan(),
    ReorderLessonPlan(),
    FetchSlidesSaga(),
    CreateSlideSaga(),
    ReorderSlidesSaga(),
    UpdateSlideSaga(),
    UploadSlideImageSaga(),
    CreateRoomSaga(),
    FetchExercisesSaga(),
    UpdateExercisesSaga(),
    DeleteExerciseSaga(),
    CreateExerciseSaga(),
    ExtendLessonSaga(),
    AddChatMessageNotificationSaga(),
    RemoveSlideSaga(),
    SendResetPasswordLinkSaga(),
    UpdatePasswordSaga(),
    CreateTutorSaga(),
    DeleteLessonPlanSaga()
  ])
}
